module.exports = __webpack_public_path__ + "static/media/3ecf11c3-20b5-4241-9105-4ba6ac1f26d9_1.83496ae55ae2e064ed56a684009c3667.1575c88b.jpeg";